module.exports = __webpack_public_path__ + "img/icon_location.f782945.svg";